import $ from 'jquery';
import VideoPlayer from './video-player';
import * as events from './events';
import defaultConfigs from './default-configs';

export default $.extend(
  VideoPlayer,
  {
    events,
    create(configs) {
      return new VideoPlayer($.extend({}, defaultConfigs, configs));
    }
  }
);


/** WEBPACK FOOTER **
 ** ./src/VO2/libs/video-player/index.js
 **/